import { render, staticRenderFns } from "./Document-visit.vue?vue&type=template&id=54c4ac63&scoped=true"
import script from "./Document-visit.vue?vue&type=script&lang=js"
export * from "./Document-visit.vue?vue&type=script&lang=js"
import style0 from "./Document-visit.vue?vue&type=style&index=0&id=54c4ac63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4ac63",
  null
  
)

export default component.exports